import { useEffect } from 'react';
import { useAppDispatch, useAppSelector } from '@/shared/model';
import { fetchCreatives, mediaTupleKey, selectCreativeByTuple, selectIsCreativeMissing } from './slice';
import type { CreativeItem, MediaDimensionValue } from './types';
import { useInitCreativesAuth } from './useInitCreativesAuth';

let pendingItems = new Map<string, MediaDimensionValue>();
let scheduled = false;

export function useRequestCreative(
  value: MediaDimensionValue | null,
): CreativeItem | undefined {
  useInitCreativesAuth();

  const dispatch = useAppDispatch();
  const key = value ? mediaTupleKey(value) : '';
  const creative = useAppSelector((state) =>
    value ? selectCreativeByTuple(value)(state) : undefined,
  );
  const isMissing = useAppSelector((state) => selectIsCreativeMissing(state, key));

  useEffect(() => {
    if (creative || isMissing || !value || !key) return;

    pendingItems.set(key, value);

    if (!scheduled) {
      scheduled = true;
      Promise.resolve().then(() => {
        const items = Array.from(pendingItems.values());
        pendingItems.clear();
        scheduled = false;

        dispatch(fetchCreatives(items));
      });
    }
  }, [key, value, creative, isMissing, dispatch]);

  return creative;
}
